export * from "./event.manager";
export * from "./onboarding.service";
import { EventManager } from "./event.manager";
export const eventManager = EventManager.getInstance<any>();
